import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import './ModalSinoptic.scss'
import { min, set } from "date-fns";
import { useEffect, useState } from "react";

const ModalSinoptic = (props: {
    showModal: boolean,
    name: string,
    onHide: () => void,
}) => {
    const { t } = useTranslation()
    const [measureSteam, setMeasureSteam] = useState<number>(30);
    const [measureBankWater, setMeasureBankWater] = useState(40);
    const [measureBoiler, setMeasureBoiler] = useState(40);
    const [heightBankWater, setHeightBankWater] = useState(1);
    const [heightBoiler, setHeightBoiler] = useState(1);
    const [showArrows, setShowArrows] = useState(true);


    const [valve1, setValve1] = useState(50);
    const [valve2, setValve2] = useState(50);
    const [valve3, setValve3] = useState(50);
    const [valve4, setValve4] = useState(50);

    const baseYBankWater = 648.9;
    const baseYBoiler = 576.125297;


    const onHide = () => {
        props.onHide()
    }

    const getRandomNumber = (min: number, max: number) => {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    useEffect(() => {
        const intervalId = setInterval(() => {

            //Measure Steam
            const newMeasureSteam = getRandomNumber(30, 50);
            setMeasureSteam(newMeasureSteam);

            //Measure Bank Water
            const newMeasureBankWater = getRandomNumber(40, 60);
            setMeasureBankWater(newMeasureBankWater);

            //Measure Boiler
            const newMeasureBoiler = getRandomNumber(40, 60);
            setMeasureBoiler(newMeasureBoiler);

            //Height Bank water
            setHeightBankWater(newMeasureBankWater / 40);

            //Height Boiler
            setHeightBoiler(newMeasureBoiler / 30);

            //Valves
            setValve1(getRandomNumber(20, 70));
            setValve2(getRandomNumber(20, 70));
            setValve3(getRandomNumber(20, 70));
            setValve4(getRandomNumber(20, 70));


        }, 3000); // cada 3 segundos

        return () => clearInterval(intervalId);
    }, []);


    useEffect(() => {
        const interval = setInterval(() => {
            setShowArrows(prev => !prev);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Modal show={props.showModal} onHide={props.onHide} backdrop="static" size="xl">
            <Modal.Body className="rounded-1 " >
                <div className='ConfigParamsHeaderContainer justify-content-start justify-content-lg-center'>
                    <div className="d-flex flex-column align-items-center">
                        <span className="h4">{props.name}</span>
                    </div>
                    <div className='saveCancelButtons'>
                        <button type='button' onClick={onHide} className="btn btn-danger me-2"><i className="bi bi-x-circle"></i></button>
                    </div>
                </div>

                <div className="rounded-1 justify-content-center modal-body-sinoptic" style={{ height: '700px' }}>


                    <svg
                        className="ms-5"
                        id="svg1"
                        width={1000}
                        height={600}
                        viewBox="0 0 1322.2581 753.51593"
                        style={{ width: '95%', height: '100%' }}
                        xmlSpace="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                
                    >
                        <g
                            id="g1"
                            transform="translate(-86.889 -49.396)"
                            display="inline"
                            strokeDasharray="none"
                            strokeOpacity={1}
                        >
                            <ellipse
                                id="cmp-steam-80"
                                cx={968.87524}
                                cy={645.50256}
                                rx={46.549149}
                                ry={45.833187}
                                display="inline"
                                fill="none"
                                stroke="#000"
                                strokeWidth={6}
                            />
                            <g id="layer1" display="inline">
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={625.90082}
                                    y={297.65997}
                                    id="text111"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#009dff"
                                    fillOpacity={1}
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111"
                                        x={625.90082}
                                        y={297.65997}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#000"
                                    >
                                        {"STEAM"}
                                    </tspan>
                                </text>
                                <path
                                    id="cmp-steam-8"
                                    d="M741.278 316.894a79.782 81.21 0 01-39.916 70.344 79.782 81.21 0 01-79.807-.044 79.782 81.21 0 01-39.84-70.389"
                                    display="inline"
                                    fill="#009dff"
                                    fillOpacity={1}
                                    stroke="none"
                                    strokeWidth={5.90111}
                                />
                                <ellipse
                                    id="cmp-steam"
                                    cx={661.42993}
                                    cy={318.59677}
                                    rx={82.477997}
                                    ry={81.209419}
                                    display="inline"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={633.68073}
                                    y={359.92258}
                                    id="measure-steam"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    fillOpacity={1}
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7"
                                        x={633.68073}
                                        y={359.92258}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {measureSteam + " \xBAC"}
                                    </tspan>
                                </text>
                            </g>
                            <path
                                d="M660 402.424V500"
                                id="pipe-2"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M768.864 357.845V499.17"
                                id="pipe-2-2"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M868.864 345.845v70.268"
                                id="pipe-2-2-5"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M1263.864 141.716v49.397"
                                id="pipe-2-2-5-3"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M661.1 173.373v61.095"
                                id="pipe-1"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <g id="layer2" fill="none" fillOpacity={1} stroke="#000">
                                <path
                                    id="rect113"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M626.54388 124.14686H696.333225V172.999399H626.54388z"
                                />
                                <path
                                    id="rect113-8"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M643.21747 106.11051H679.6596430000001V123.60053300000001H643.21747z"
                                />
                                <path
                                    d="M626.007 87.187h70.863"
                                    id="path113"
                                    display="inline"
                                    strokeWidth={10.5335}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M661.439 89.064v14.416"
                                    id="path114"
                                    display="inline"
                                    strokeWidth={8.64455}
                                    strokeLinecap="square"
                                />
                                <path
                                    id="rect113-6"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M990.96899 397.84464H1060.758335V419.84464H990.96899z"
                                />
                                <path
                                    id="rect113-8-7"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M1007.6426 379.80832H1044.084773V397.298343H1007.6426z"
                                />
                                <path
                                    id="rect113-8-7-9"
                                    display="inline"
                                    strokeWidth={6.00001}
                                    d="M982.86365 391.34464H990.8636233V426.344671H982.86365z"
                                />
                                <path
                                    id="rect113-8-7-9-5"
                                    display="inline"
                                    strokeWidth={6.00001}
                                    d="M1062.8636 391.34464H1070.8635732999999V426.344671H1062.8636z"
                                />
                                <path
                                    d="M990.432 360.885h70.863"
                                    id="path113-7"
                                    display="inline"
                                    strokeWidth={10.5335}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M1025.864 362.762v14.416"
                                    id="path114-2"
                                    display="inline"
                                    strokeWidth={8.64455}
                                    strokeLinecap="square"
                                />
                                <path
                                    id="rect113-6-2"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M990.96899 137.49158H1060.758335V159.49158H990.96899z"
                                />
                                <path
                                    id="rect113-8-7-5"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M1007.6426 119.45524H1044.084773V136.945263H1007.6426z"
                                />
                                <path
                                    id="rect113-8-7-9-0"
                                    display="inline"
                                    strokeWidth={6.00001}
                                    d="M982.86365 130.99158H990.8636233V165.991611H982.86365z"
                                />
                                <path
                                    id="rect113-8-7-9-5-8"
                                    display="inline"
                                    strokeWidth={6.00001}
                                    d="M1062.8636 130.99158H1070.8635732999999V165.991611H1062.8636z"
                                />
                                <path
                                    d="M990.432 100.532h70.863"
                                    id="path113-7-3"
                                    display="inline"
                                    strokeWidth={10.5335}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M1025.864 102.409v14.416"
                                    id="path114-2-9"
                                    display="inline"
                                    strokeWidth={8.64455}
                                    strokeLinecap="square"
                                />
                            </g>
                            <g id="layer3" fill="none" fillOpacity={1} stroke="#000">
                                <path
                                    id="rect113-9"
                                    display="inline"
                                    strokeWidth={6}
                                    d="M385.91736 115.07502H420.754598V172.940499H385.91736z"
                                />
                                <path
                                    d="M368.881 90.697h70.863"
                                    id="path113-4"
                                    display="inline"
                                    strokeWidth={10.5335}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M403.024 95.49v14.416"
                                    id="path114-3"
                                    display="inline"
                                    strokeWidth={8.64455}
                                    strokeLinecap="square"
                                />
                                <path
                                    id="rect113-9-7"
                                    display="inline"
                                    strokeWidth={4}
                                    d="M913.75604 633.5979H923.3232054V650.938213H913.75604z"
                                />
                            </g>
                            <path
                                d="M424.067 148.562h199.61"
                                id="pipe-5"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={13.9961}
                            />
                            <path
                                d="M402.552 641.92h124.242"
                                id="pipe-5-7"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M787.53 641.612h124.242"
                                id="pipe-5-7-8"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M269.02 148.444h114.276"
                                id="pipe-4"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M282.816 310.552h114.277"
                                id="pipe-4-6"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                d="M403.57 175.954v472.693"
                                id="pipe-2-99"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={14}
                            />
                            <path
                                id="cmp-desuperheater"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={8.35228}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit={4}
                                d="M257.08691 234.83984H463.31491V519.68176H257.08691z"
                            />
                            <g id="layer5" fillOpacity={1}>
                                <path
                                    id="rect115"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={20.2329}
                                    strokeLinecap="square"
                                    d="M98.528877 131.4577H262.171747V159.36219499999999H98.528877z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        fontFamily: "Segoe UI",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={102.37968}
                                    y={154.20667}
                                    id="text111-0"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-2"
                                        x={102.37968}
                                        y={154.20667}
                                        style={{
                                        fontFamily: "Segoe UI",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {"STEAM OUT"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="measure-valve-1"
                                transform="translate(35.864 -183.887)"
                                display="inline"
                                fillOpacity={1}
                                stroke="none"
                            >
                                <path
                                    id="rect115-4"
                                    display="inline"
                                    fill="#666"
                                    strokeWidth={20.2329}
                                    strokeLinecap="square"
                                    d="M329.12741 235.56332H407.770293V263.46781500000003H329.12741z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={338.98535}
                                    y={257.28119}
                                    id="measure-steam-81"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7-2"
                                        x={338.98535}
                                        y={257.28119}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {valve1 + " %"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="measure-valve-2"
                                transform="translate(35.864 -183.887)"
                                display="inline"
                                fillOpacity={1}
                                stroke="none"
                            >
                                <path
                                    id="rect115-4-3"
                                    display="inline"
                                    fill="#666"
                                    strokeWidth={20.2329}
                                    strokeLinecap="square"
                                    d="M585.14209 233.28214H663.784973V261.186635H585.14209z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={595}
                                    y={255}
                                    id="measure-steam-81-0"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7-2-7"
                                        x={595}
                                        y={255}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {valve2 + " %"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="measure-valve-4"
                                transform="translate(35.864 -183.887)"
                                display="inline"
                                fillOpacity={1}
                                stroke="none"
                            >
                                <path
                                    id="rect115-4-37"
                                    display="inline"
                                    fill="#666"
                                    strokeWidth={20.2329}
                                    strokeLinecap="square"
                                    d="M950 506.11545H1028.642883V534.019945H950z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={959.85791}
                                    y={527.83331}
                                    id="measure-steam-81-2"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7-2-9"
                                        x={959.85791}
                                        y={527.83331}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {valve4 + " %"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="measure-valve-3"
                                transform="translate(35.864 -183.887)"
                                display="inline"
                                fillOpacity={1}
                                stroke="none"
                            >
                                <path
                                    id="rect115-4-0"
                                    display="inline"
                                    fill="#666"
                                    strokeWidth={20.2329}
                                    strokeLinecap="square"
                                    d="M950 246.04774H1028.642883V273.95223500000003H950z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={959.85791}
                                    y={267.76562}
                                    id="measure-steam-81-3"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7-2-8"
                                        x={959.85791}
                                        y={267.76562}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {valve3 + " %"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="label-desuperheater"
                                transform="translate(35.864 -183.887)"
                                fillOpacity={1}
                            >
                                <path
                                    id="rect115-0"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={22.8729}
                                    strokeLinecap="square"
                                    d="M62.461365 481.517H293.44935499999997V506.781448H62.461365z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={63.197647}
                                    y={502.94592}
                                    id="text111-0-1"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                    paintOrder="stroke fill markers"
                                >
                                    <tspan
                                        id="tspan111-2-2"
                                        x={63.197647}
                                        y={502.94592}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                        paintOrder="stroke fill markers"
                                    >
                                        {"DESUPERHEATER"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="label-bank-of-water"
                                transform="translate(35.864 -183.887)"
                                fillOpacity={1}
                            >
                                <path
                                    id="rect115-1"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={22.6788}
                                    strokeLinecap="square"
                                    d="M508.56287 694.39709H733.91297V719.8557370000001H508.56287z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={511.1908}
                                    y={715.92316}
                                    id="text111-0-3"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-2-8"
                                        x={511.1908}
                                        y={715.92316}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {"BANK OF WATER"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="label-bank-of-water-4"
                                transform="translate(595.864 -143.887)"
                                display="inline"
                                fillOpacity={1}
                            >
                                <path
                                    id="rect115-1-4"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={22.6788}
                                    strokeLinecap="square"
                                    d="M531.84589 693.76263H801.94361V719.221277H531.84589z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={534.47382}
                                    y={715.2887}
                                    id="text111-0-3-0"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-2-8-5"
                                        x={534.47382}
                                        y={715.2887}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {"BOILER FEED PUMP"}
                                    </tspan>
                                </text>
                            </g>
                            <g id="cmp-bank-of-water" display="inline" fillOpacity={1}>
                                <path
                                    d="M659.431 546.979v101.389"
                                    id="pipe-2-9"
                                    display="inline"
                                    fill="none"
                                    stroke="#009dff"
                                    strokeWidth={14.2709}
                                />
                                <path
                                    id="rect116"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={5.71026}
                                    strokeLinecap="square"
                                    d="M529.12653 544.44324H785.57987V651.50522H529.12653z"
                                />
                                <g transform={`translate(0, ${baseYBankWater}) scale(1, ${heightBankWater}) translate(0, ${-baseYBankWater})`}>

                                    <path
                                        id="height-bank-water"
                                        fill="#009dff"
                                        stroke="none"
                                        strokeWidth={3.82024}
                                        strokeLinecap="square"
                                        d="M531.86749 599.89056H782.61079V648.9004970000001H531.86749z"
                                    />
                                </g>
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={621.62512}
                                    y={635.87531}
                                    id="measure-bank"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7-4"
                                        x={621.62512}
                                        y={635.87531}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {measureBankWater + " %"}
                                    </tspan>
                                </text>
                                <path
                                    id="rect116-6"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6.43606}
                                    strokeLinecap="round"
                                    d="M529.44568 652.02698H785.17322V788.42089H529.44568z"
                                />
                                <path
                                    d="M558.65 674.205c25.021 7.61-13.843 80.939 2.22 91.678"
                                    id="hot-line-1"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M597.553 673.969c25.022 7.61-13.842 80.938 2.22 91.677"
                                    id="hot-line-2"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M634.043 673.776c25.021 7.61-13.842 80.939 2.22 91.678"
                                    id="hot-line-3"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M672.712 674.175c25.512 11.042-13.842 80.939 2.22 91.678"
                                    id="hot-line-4"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M710.795 673.976c25.022 7.61-13.842 80.938 2.22 91.678"
                                    id="hot-line-5"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M749.492 673.422c25.022 7.61-13.842 80.938 2.22 91.678"
                                    id="hot-line-6"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={6}
                                    strokeLinecap="round"
                                />
                            </g>
                            <path
                                d="M524.48 788.676H241.514"
                                id="path118"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={6}
                                strokeLinecap="square"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M241.864 789.32v-78.247"
                                id="path118-7"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={6}
                                strokeLinecap="square"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M172.046 659.506v-323.64"
                                id="path118-7-8"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={6.07797}
                                strokeLinecap="square"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M1265.864 540.1V432.268"
                                id="path118-7-8-2"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={6.07796}
                                strokeLinecap="square"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <g
                                id="label-bank-of-water-2"
                                transform="translate(-272.36 -76.944)"
                                display="inline"
                                fillOpacity={1}
                            >
                                <path
                                    id="rect115-1-0"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={21.947}
                                    strokeLinecap="square"
                                    d="M425.0842 749.86267H630.22928V776.053104H425.0842z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={428.07803}
                                    y={771.75464}
                                    id="text111-0-3-1"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-2-8-6"
                                        x={428.07803}
                                        y={771.75464}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {"DESUPERHATE"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="4arrows"
                                transform="translate(346.691 246.637)"
                                fill="currentColor"
                                fillRule="evenodd"
                                stroke="#009dff"
                            >
                                <path
                                    d="M20.112 525.453a1.109 1.109 0 001.109-1.109v-26.146l6.975 6.977a1.11 1.11 0 001.57-1.57l-8.869-8.868a1.109 1.109 0 00-1.57 0l-8.868 8.868a1.11 1.11 0 101.57 1.57l6.975-6.977v26.146a1.109 1.109 0 001.108 1.109"
                                    id="path1"
                                    strokeWidth={3.3257}
                                />
                                <path
                                    d="M57.478 525.709a1.109 1.109 0 001.109-1.109v-26.147l6.975 6.978a1.11 1.11 0 001.57-1.57l-8.869-8.869a1.109 1.109 0 00-1.57 0l-8.868 8.869a1.11 1.11 0 101.57 1.57l6.975-6.978V524.6a1.109 1.109 0 001.108 1.109"
                                    id="path1-8"
                                    display="inline"
                                    fill="currentColor"
                                    strokeWidth={3.3257}
                                />
                                <path
                                    d="M94.36 525.711a1.109 1.109 0 001.11-1.109v-26.146l6.974 6.977a1.11 1.11 0 001.57-1.57l-8.869-8.868a1.109 1.109 0 00-1.57 0l-8.868 8.868a1.11 1.11 0 101.57 1.57l6.975-6.977v26.146a1.109 1.109 0 001.108 1.109"
                                    id="path1-8-7"
                                    display="inline"
                                    fill="currentColor"
                                    strokeWidth={3.3257}
                                />
                                <path
                                    d="M130.137 525.606a1.109 1.109 0 001.109-1.109v-26.146l6.975 6.977a1.11 1.11 0 001.57-1.57l-8.869-8.868a1.109 1.109 0 00-1.57 0l-8.868 8.868a1.11 1.11 0 101.57 1.57l6.975-6.977v26.146a1.109 1.109 0 001.108 1.109"
                                    id="path1-8-71"
                                    display="inline"
                                    fill="currentColor"
                                    strokeWidth={3.326}
                                    strokeLinecap="square"
                                    strokeLinejoin="miter"
                                />
                            </g>
                            <g
                                id="arrow-6"
                                transform="translate(35.864 -183.887)"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-5"
                                transform="translate(-156.983 -185.68)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-0"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-45"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-3"
                                transform="rotate(90 408.547 327.537)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-8"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-4"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-4"
                                transform="rotate(90 482.044 253.63)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-8-4"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-4-8"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-2"
                                transform="rotate(90 337.044 398.63)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-8-8"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-4-2"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-1"
                                transform="translate(-2.77 308.944)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-8-3"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-4-3"
                                    display="inline"
                                />
                            </g>
                            <path
                                d="M948.355 632.912h41.556"
                                id="path119"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={5}
                                strokeLinecap="round"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M948.672 643.8h41.556"
                                id="path119-8"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={5}
                                strokeLinecap="round"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M948.513 654.09h41.556"
                                id="path119-1"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={5}
                                strokeLinecap="round"
                                strokeLinejoin="miter"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M950.677 691.147l-20.969 14.396h78.334l-21.24-15.514v0"
                                id="path120"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={4.07093}
                                strokeLinecap="square"
                                strokeLinejoin="round"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <path
                                d="M699.345 148.85h280.519"
                                id="pipe-5-7-8-8"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={13.9999}
                            />
                            <path
                                d="M875.864 409.114h104"
                                id="pipe-5-7-8-8-9"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={13.9999}
                            />
                            <path
                                d="M1073.864 408.813h104"
                                id="pipe-5-7-8-8-9-9"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={13.9999}
                            />
                            <path
                                d="M1073.864 148.716h197"
                                id="pipe-5-7-8-8-9-4"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={13.9999}
                            />
                            <path
                                d="M761.864 352.845h104"
                                id="pipe-5-7-8-8-9-3"
                                display="inline"
                                fill="none"
                                fillOpacity={1}
                                stroke="#009dff"
                                strokeWidth={13.9999}
                            />
                            <g
                                id="label-bank-of-water-7"
                                transform="translate(344.626 26.716)"
                                display="inline"
                                fillOpacity={1}
                            >
                                <path
                                    id="rect115-1-6"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={22.6788}
                                    strokeLinecap="square"
                                    d="M528.07013 694.39709H714.4057799999999V719.8557370000001H528.07013z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={531.23792}
                                    y={714.39709}
                                    id="text111-0-3-2"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        x={531.23792}
                                        y={714.39709}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        id="tspan120"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {"BOILER FEED"}
                                    </tspan>
                                </text>
                                <path
                                    id="rect115-1-6-3"
                                    display="inline"
                                    fill="#000"
                                    stroke="#000"
                                    strokeWidth={22.6788}
                                    strokeLinecap="square"
                                    d="M579.40955 739.39709H661.237942V764.8557370000001H579.40955z"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                        textAlign: "start"
                                    }}
                                    x={582.34192}
                                    y={761.02155}
                                    id="text111-0-3-2-9"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight={400}
                                    fontStretch="normal"
                                    fontSize="26.6667px"
                                    fontFamily="Segoe UI"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        x={582.34192}
                                        y={761.02155}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        id="tspan120-1"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="26.6667px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {"PUMP"}
                                    </tspan>
                                </text>
                            </g>
                            <g
                                id="cmp-boiler-feed-pump"
                                transform="translate(35.864 -183.887)"
                                fillOpacity={1}
                            >
                                <ellipse
                                    id="path121"
                                    cx={1227}
                                    cy={400.6593}
                                    rx={87.5}
                                    ry={25}
                                    display="inline"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={4}
                                    strokeLinecap="square"
                                    strokeLinejoin="round"
                                    strokeMiterlimit={4}
                                    paintOrder="stroke fill markers"
                                />
                                <path
                                    d="M1144.136 573.886l-.136 47.638c55.333 24.51 110.667 23.524 166 0l.952-48.356"
                                    id="path122-2"
                                    display="inline"
                                    fill="#009dff"
                                    stroke="none"
                                    strokeWidth={4}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit={4}
                                    paintOrder="stroke fill markers"
                                />
                                <path
                                    d="M1142 409.66v209.32c56.667 27.574 113.333 27.574 170 0V407"
                                    id="path122"
                                    display="inline"
                                    fill="none"
                                    stroke="#000"
                                    strokeWidth={4}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit={4}
                                    paintOrder="stroke fill markers"
                                />
                                <text
                                    xmlSpace="preserve"
                                    style={{

                                        textAlign: "start"
                                    }}
                                    x={1188.0853}
                                    y={600.48633}
                                    id="measure-boiler"
                                    fontStyle="italic"
                                    fontSize="21.3333px"
                                    fontFamily="Arial"
                                    writingMode="lr-tb"
                                    direction="ltr"
                                    textAnchor="start"
                                    display="inline"
                                    fill="#000"
                                    stroke="none"
                                    strokeWidth={6}
                                >
                                    <tspan
                                        id="tspan111-7-4-4"
                                        x={1188.0853}
                                        y={600.48633}
                                        style={{

                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal"
                                        }}
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight={400}
                                        fontStretch="normal"
                                        fontSize="21.3333px"
                                        fontFamily="Segoe UI"
                                        fill="#fff"
                                    >
                                        {measureBoiler + " %"}
                                    </tspan>
                                </text>
                                <g transform={`translate(0, ${baseYBoiler}) scale(1, ${heightBoiler}) translate(0, ${-baseYBoiler})`}>

                                    <path
                                        id="height-bank-water-2"
                                        display="inline"
                                        fill="#009dff"
                                        stroke="none"
                                        strokeWidth={3.82024}
                                        strokeLinecap="square"
                                        d="M1144 527.11536H1310.13635V576.125297H1144z"
                                    />
                                </g>

                            </g>
                            <path
                                d="M1116.37 562.605H969.133l-.258 37.064"
                                id="path123"
                                fill="none"
                                fillOpacity={1}
                                stroke="#000"
                                strokeWidth={4}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit={4}
                                paintOrder="stroke fill markers"
                            />
                            <g
                                id="arrow-9"
                                transform="matrix(-1 0 0 1 1651.356 -183.258)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-2"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-1"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-8"
                                transform="matrix(-1 0 0 1 1379.649 -184.143)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-2-3"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-1-1"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-7"
                                transform="matrix(-1 0 0 1 1279.492 -183.372)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-2-3-0"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-1-1-6"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-13"
                                transform="matrix(-1 0 0 1 1344.846 309.332)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-2-7"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-1-0"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-12"
                                transform="rotate(-90 675.123 238.62)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-1"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-2"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-11"
                                transform="translate(428.782 76.594)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-2-7-7"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-1-0-3"
                                    display="inline"
                                />
                            </g>
                            <g
                                id="arrow-10"
                                transform="translate(630.94 75.634)"
                                display="inline"
                                fill="none"
                                style={{
                                    opacity: showArrows ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                                stroke="#009dff"
                                strokeWidth={10}
                            >
                                <path
                                    d="M499.846 315.668l-22.863 20.012"
                                    id="pipe-4-6-9-2-7-7-5"
                                    display="inline"
                                />
                                <path
                                    d="M500.492 349.372L477.63 329.36"
                                    id="pipe-4-6-9-9-1-0-3-7"
                                    display="inline"
                                />
                            </g>
                        </g>
                    </svg>











                </div>

            </Modal.Body>
        </Modal >
    )
}

export default ModalSinoptic